import { styled } from '@mui/material/styles';
import LoaderSpinner from '../../../../../../../elements/LoaderSpinner';

export const SurveyWrapper = styled('form')(
  ({ theme }) => `
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: auto;
  width: 100%;
   ${theme.breakpoints.up('md')} {
     margin-bottom: ${theme.DS_spacing(['xl'])};
   }
`,
);

export const OutterSurveyWrapper = styled('div')(
  ({ $isSending }) => `
  height: 90%;
  display: flex;
  justify-content: ${$isSending ? 'center' : 'flex-start'};
  flex-direction: column;
  align-items: center;

`,
);

export const StyledLoaderSpinner = styled(LoaderSpinner)(
  ({ theme }) => `
  margin: ${theme.DS_spacing(['xl'])} auto !important;

`,
);
